export const getYouTubeVideoId = (url) => {
  if (!url) return null;

  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);

  console.log(match,'urllllll')

  return match && match[2].length === 11 ? match[2] : null;
};